import { render, staticRenderFns } from "./supplierBusinessDocuments.vue?vue&type=template&id=716a8eae&"
import script from "./supplierBusinessDocuments.vue?vue&type=script&lang=js&"
export * from "./supplierBusinessDocuments.vue?vue&type=script&lang=js&"
import style0 from "./supplierBusinessDocuments.vue?vue&type=style&index=0&id=716a8eae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports